module.exports = __webpack_public_path__ + "static/img/img1.0faf173.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/AboutUs/img/img1.jpg
// module id = iH4v
// module chunks = 1